import { Image } from "react-native";
import React from "react";

const ImageView = ({ source, prefetch, resizeMode, style, children, alt = "Image" }) => {
    return (
        <Image
            alt={alt}
            accessibilityLabel={alt}
            source={source}
            prefetch={prefetch}
            resizeMode={resizeMode}
            style={style}
        >
            {children}
        </Image>
    );
};

ImageView.resizeMode = {
    contain: "contain",
    cover: "cover",
    stretch: "stretch",
    center: "center",
};

ImageView.priority = {
    low: "low",
    normal: "normal",
    high: "high",
};

ImageView.cacheControl = {
    immutable: "immutable",
    web: "web",
    cacheOnly: "cacheOnly",
};

export default ImageView;
